import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {gql, Apollo} from 'apollo-angular';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { ProductService } from 'src/app/_services/product.services';
import { Meta, Title } from '@angular/platform-browser';
import { OthersService } from 'src/app/_services/others.service';
import { getIdRfq } from 'src/app/_helpers/getIdRfq';




const querycompanyProducts = gql`
query companyProducts($first: Int, $after: String) {
  companyProducts(input: {first: $first, after: $after}) {
        pageInfo{
            endCursor
            hasNextPage
        }
        edges{
            cursor
            node{
                id
                name
                brand
                description
                sku
                manufacturerSku
                price
                imageUrl
                tags{
                    id
                    tag
                }
                isDisplayPriceOnShopfront
                isDisplayProductOnShopfront
                quotationInitialPriceOffer
                autobidMinimumPrice
                autobidPriceDecrement
                isAutobidEnabled

                state    
                publishApprovalStatus
                publishedOngoingApprovalStatus
                isActivatedByUser
                createdDate
                createdBy
                modifiedDate
                modifiedBy
            }
        }
  }
}
`;


@Component({
  selector: 'app-products-catalogue',
  templateUrl: './products-catalogue.component.html',
  styleUrls: ['./products-catalogue.component.scss']
})
export class ProductsCatalogueComponent implements OnInit {
  keyword:string=''
  prevkeyword:string=''
  offset:number=0
  currentpage:number=1
  totalpage:number =0
  totaldata:number=0
  pagingloading:boolean=false

  BulkLabel:string="Bulk Action"
  first : number = 20
  ValPaging:any = 20
  PageLoading:boolean=false
  loadingNext:boolean=false
  dataProducts: any
  AlldataProducts : any =[]
  endCursor: any
  hasNextPage: any

  hasPrevPage:any
  arrPrevCursor:any=[]
  
  deleteID : any = []
  deleteName : any = []

  LastResult:boolean=false
  isLogin:boolean=false

  isMobile:boolean=false
  innerWidth: number=0;


  currentRoute:string=''


  OnRfqSearch:boolean=false
  dataRfqBoard:any=[]
  ValPagingRFQ:any = 40

  items: any[] = [];
  page = 1;
  limit = 10;
  loading = false;
  hasMore = true;


  constructor(
    private apollo: Apollo,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private authService: AuthService,
    private productService: ProductService,
    private othersService: OthersService,
    private meta: Meta,
    private titleService: Title,
  ) { 
    // this.currentRoute = "";
    // var getketword  = this.route.snapshot.paramMap.get('keyword');
    // var titleShare = ''
    // if(getketword){
    //   titleShare = decodeURIComponent(getketword)
    // }
    // this.router.events.subscribe((event) => {
    //     if (event instanceof NavigationStart) {
    //         // Show progress spinner or progress bar
    //         // console.log('Route change detected');
    //         // alert('Route change detected')
    //     }

    //     if (event instanceof NavigationEnd) {
    //         // Hide progress spinner or progress bar
    //         this.currentRoute = event.url;          
    //         // console.log(event);
    //         // alert(event)

    //         // var getketword  = this.route.snapshot.paramMap.get('keyword');
    //         console.log('EditProductId',getketword);
    //         if(getketword){
    //           this.keyword= getketword
    //           this.prevkeyword = decodeURIComponent(getketword)
    //         }
    //         this.getsearch()

    //     }

    //     if (event instanceof NavigationError) {
    //          // Hide progress spinner or progress bar

    //         // Present error to user
    //         console.log(event.error);
    //         alert('error')
    //     }
    // });

    // //get rfq keyword
    // var getketwordRfq  = this.route.snapshot.paramMap.get('keywordRfq');
    // var titleShare = ''
    // if(getketwordRfq){
    //   titleShare = decodeURIComponent(getketwordRfq)
    //   this.OnRfqSearch = true
    // }
    // this.router.events.subscribe((event) => {
    //     if (event instanceof NavigationStart) {
    //         // Show progress spinner or progress bar
    //         // console.log('Route change detected');
    //         // alert('Route change detected')
    //     }

    //     if (event instanceof NavigationEnd) {
    //         // Hide progress spinner or progress bar
    //         this.currentRoute = event.url;          
    //         // console.log(event);
    //         // alert(event)

    //         // var getketword  = this.route.snapshot.paramMap.get('keyword');
    //         console.log('EditProductId',getketwordRfq);
    //         if(getketwordRfq){
    //           this.keyword= getketwordRfq
    //           this.prevkeyword = decodeURIComponent(getketwordRfq)
    //         }
    //         this.getsearchRFQ()

    //     }

    //     if (event instanceof NavigationError) {
    //          // Hide progress spinner or progress bar

    //         // Present error to user
    //         console.log(event.error);
    //         alert('error')
    //     }
    // });


    	// //Set Open Graph
      // this.meta.updateTag({property: 'og:title', content: 'Temukan '+titleShare+' di CepetDapet.com'});
      // // this.meta.updateTag({property: 'og:image', content: 'image'});
      // this.meta.updateTag({property: 'og:url', content: window.location.href});
      // // this.meta.updateTag({property: 'og:description', content: 'desc'});

      // //Set Twitter Share
      // this.meta.updateTag({name: 'twitter:title', content: 'Temukan '+titleShare+' di CepetDapet.com'});
      // // this.meta.updateTag({name: 'twitter:image', content: 'image twitter'});
      // this.meta.updateTag({name: 'twitter:url', content: window.location.href});
      // //this.meta.updateTag({name: 'twitter:description', content: 'desc twitter'});

      // this.loadMore();
  }

  ngOnInit(): void {
    this.loadMore();

   


    // this.innerWidth = window.innerWidth;
    // console.log('this.innerWidth',this.innerWidth);
    // if(this.innerWidth < 992){
    //   this.isMobile=true
    //   this.ValPaging = 4
    // } else {
    //   this.isMobile=false
    //   this.ValPaging = 20
    // }

    
    // if (localStorage.getItem("COMPANYSELECTID") !== null) {
    //   this.isLogin = true
    // } 


    // var getketword  = this.route.snapshot.paramMap.get('keyword');
    // console.log('EditProductId',getketword);
    // if(getketword){
    //   this.keyword= getketword
    //   this.prevkeyword = decodeURIComponent(getketword)
    //   this.getsearch()
    // }
    
    // var getketwordRfq  = this.route.snapshot.paramMap.get('keywordRfq');
    // console.log('EditProductId',getketwordRfq);
    // if(getketwordRfq){
    //   this.keyword= getketwordRfq
    //   this.prevkeyword = decodeURIComponent(getketwordRfq)
    //   this.getsearchRFQ()
    // }
    
    // if(getketwordRfq){
    //   this.titleService.setTitle('Search RFQ '+this.keyword+' | CepetDapet')
    // } else {
    //   this.titleService.setTitle('Search Product '+this.keyword+' | CepetDapet')
    // }


  }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.innerWidth = window.innerWidth;
      //console.log('innerWidth',this.innerWidth);
  
      if(this.innerWidth < 992){
        this.isMobile=true
      } else {
        this.isMobile=false
      }
    }


  // loadMore(){
  //   let first = this.first
  //   let after = this.endCursor
  //   this.loadingNext = true
  //   this.apollo
  //   .mutate({
  //     mutation: querycompanyProducts,
  //     variables: {first: first, after: after}
  //   })
  //   .subscribe(
  //     (res:any) => {
  //       console.log("succes, get loadMore data:", res);

  //       this.loadingNext = false
  //       if(res.data){
  //         console.log("ada data");
  //         this.PageLoading=false
  //         this.dataProducts = res.data.companyProducts.edges
  //         var arrProd = res.data.companyProducts.edges

  //         var arrProd = res.data.companyProducts.edges
  //         arrProd.forEach((value: any, key: any) => {
  //           this.AlldataProducts.push(value)
  //         })

  //         this.endCursor = res.data.companyProducts.pageInfo.endCursor
  //         this.hasNextPage = res.data.companyProducts.pageInfo.hasNextPage
  //         console.log('endCursor',this.endCursor);
  //         console.log('hasNextPage',this.hasNextPage);

  //         localStorage.removeItem('PRODUCTLIST');
  //         localStorage.setItem('PRODUCTLIST', JSON.stringify(this.AlldataProducts));

  //       }
  //     },
  //     error => {
  //       alert(error)
  //       console.log("there was an error sending the query", error);     
  //       this.PageLoading=false  
  //       this.loadingNext = false     
  //     }
  //   );    
  // }






  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
      this.loadMore();
    }
  }

  loadMore(): void {
    if (this.PageLoading || !this.hasMore) return;

    // this.loading = true;
    // this.productService.fetchItems(this.page, this.limit).subscribe(response => {
    //   if (response.length > 0) {
    //     this.items.push(...response);
    //     this.page++;
    //   } else {
    //     this.hasMore = false; // No more items to load
    //   }
    //   this.loading = false;
    // }, () => {
    //   this.loading = false;
    // });

    this.PageLoading=true
    this.productService.getUserViewGlobalProductCatalog(this.ValPaging,this.offset)
    .subscribe((res:any) => {
      console.log("getUserViewGlobalProductCatalog ",res)
      

      if(res.data?.userViewGlobalProductCatalog){
          //console.log("ada data");


          // this.AlldataProducts=[]
          var arrProd = res.data.userViewGlobalProductCatalog.productGlobalDetail
          // arrProd.forEach((value: any, key: any) => {
          //   this.AlldataProducts.push(value)
          // })

          if (arrProd.length > 0) {
            arrProd.forEach((value: any, key: any) => {
              console.log('value : ',value)
              this.AlldataProducts.push(value)
            })

            this.currentpage++;
          } else {
            this.hasMore = false; // No more items to load
          }
          


          this.offset = this.currentpage*this.ValPaging
          this.PageLoading = false

          console.log('currentpage : ',this.currentpage)
          console.log('limit : ',this.limit)
           console.log('offset : ',this.offset)
      }
      else if(res.errors){
   
        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })

        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = errortext
        modalRef.componentInstance.closeTxt = 'Close'

        this.PageLoading = false
      }
      else {
        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })
        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = 'Please try again later'
        modalRef.componentInstance.closeTxt = 'Close'

        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res){
            this.router.navigate(['/']);
          } 
        })

        this.PageLoading = false
      }
      
    });



  }


}
